import src from "IMAGE";
export default { src, width: 534, height: 436, blurWidth: 0, blurHeight: 0};
